import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {applicantRequestPasswordReset} from '../../../auth/core/_requests'
import {useAuth} from '../../../auth/core/Auth'
import { useNavigate } from "react-router-dom";

const initialValues = {
    email: '',
}

const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string().trim()
        .email('Please enter a valid email address.')
        .min(3, 'Minimum 3 symbols')
        .max(200)
        .required('Email is required'),
})

export function CompanyForgotPassword() {
    
    const navigate = useNavigate();    
    const {saveAuth} = useAuth()

    const [loading, setLoading] = useState(false)
    const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
    const formik = useFormik({
        initialValues,
        validationSchema: forgotPasswordSchema,
        onSubmit: (values, {setSubmitting}) => {
            setLoading(true)
            setSubmitting(true);
            setHasErrors(undefined)

            async function requestPassword() {
                await applicantRequestPasswordReset(values.email)                    
                .then( res => {                    
                    saveAuth( {                            
                        email: values.email,
                        password: '-forgot',
                        loggedIn: false,
                        id: 0,
                        isSetsco: false,                             
                    })
                })
                .catch((error) => {
                    console.error(error)
                    saveAuth(undefined)                    
                })
                .finally(() =>  {
                    setSubmitting(false)
                    setLoading(false)                
                    navigate("/auth/forgot-password-otp");
                });            
            }
            requestPassword();            
        },
    })

    return (
    <>
    <form
        className='form w-100 bg-white rounded-4 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
    >
        <div className="p-10 d-flex flex-column gap-4 mb-10">
            <div className='text-center mb-10'>
                <h1 className='text-dark fw-bolder mb-3'>Reset/Forgot Password ?</h1>                
                <div className='text-gray-500 fw-semibold fs-6'>
                    Enter your email to reset your password.
                </div>                
            </div>
            
            {hasErrors === true && (
            <div className='mb-lg-15 alert alert-danger'>
                <div className='alert-text font-weight-bold'>
                    Sorry, looks like there are some errors detected, please try again.
                </div>
            </div>
            )}

            {hasErrors === false && (
            <div className='mb-10 bg-light-info p-8 rounded'>
                <div className='text-info'>Sent password reset. Please check your email</div>
            </div>
            )}

            <div className='fv-row mb-8'>
                <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
                <input
                    type='email'
                    placeholder=''
                    autoComplete='off'
                    {...formik.getFieldProps('email')}
                    className={clsx(
                        'form-control bg-transparent',
                        {'is-invalid': formik.touched.email && formik.errors.email},
                        {'is-valid': formik.touched.email && !formik.errors.email,}
                    )}
                />
                {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.email}</span>
                    </div>
                </div>
                )}
            </div>

            <div className='d-flex flex-wrap justify-content-center pb-lg-0 gap-2'>
                <button
                    type='submit'
                    id='kt_password_reset_submit'
                    className='btn btn-primary px-10'
                    disabled={formik.isSubmitting || !formik.isValid}
                >
                    {!loading && <span className='indicator-label'>Submit</span>}
                    {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                    )}
                </button>
                
                <Link to='/auth/login'>
                    <button
                        type='button'
                        id='kt_login_password_reset_form_cancel_button'
                        className='btn btn-secondary'
                        disabled={formik.isSubmitting || !formik.isValid}
                    >
                        Cancel
                    </button>
                </Link>{' '}
            </div>

        </div>
    </form>    
    </>
    )
}
